import PropTypes from 'prop-types'
import React from 'react'
import RadioButtons from '../../../../internal/RadioButtons'
import { getText } from '../../../../internal/TextLabels'
import { PayApplyIdType } from '../../../../models/payapply'

const IdentificationTypeSelector = ({
  id,
  label,
  onChange,
  value,
  disabled,
}) => (
  <RadioButtons
    id={id}
    label={label}
    values={[
      {
        key: PayApplyIdType.DRIVERS_LICENCE,
        value: PayApplyIdType.DRIVERS_LICENCE,
        valueLabel: getText('payApply.identify.type.driverslicence'),
        disabled,
      },
      {
        key: PayApplyIdType.PASSPORT,
        value: PayApplyIdType.PASSPORT,
        valueLabel: getText('payApply.identify.type.passport'),
        disabled,
      },
      {
        key: PayApplyIdType.ID,
        value: PayApplyIdType.ID,
        valueLabel: getText('payApply.identify.type.id'),
        disabled,
      },
    ]}
    onChange={onChange}
    defaultValue={value}
  />
)

IdentificationTypeSelector.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  disabled: PropTypes.bool,
}

IdentificationTypeSelector.defaultProps = {
  value: null,
  disabled: false,
}

export default IdentificationTypeSelector
